var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTapirHex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3705E;stroke:#F5F5F5;stroke-width:10px}\n\t.st1{display:none;fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st2{display:none;fill:#55494B;}\n\t.st3{fill:#F5F5F5;}\n\t.st4{fill:#55494B;}\n\t.st5{fill:none;stroke:#000000;stroke-width:6;stroke-miterlimit:10;}\n\t.st6{fill:#55494B;stroke:#55494B;stroke-width:6;stroke-miterlimit:10;}\n\t.st7{fill:#DC2855;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "924.9,252.5 926.8,744.2 501.9,991.7 75.1,747.5 73.2,255.8 498.1,8.3  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "all"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cntr",
    className: "st1",
    d: "M574.7,583.4c-11.4,38.4-29.2,59.6-43.2,71.8c-18.5,16.1-39.9,24.8-41.7,44 c-1.1,12.7,7.6,15.9,6.7,30c-1.2,18.2-17.5,37.3-36.7,41.7c-17.1,4-34.2-5-53.8-21.6c-93-78.4-114.5-201.1-114.5-201.1 c-8.1-46.5-17.9-102.3,10.5-163.8c25.6-55.5,70.8-90,101-104.8c8.5-4.2,35.4-16.5,72.7-20.2c2.2-0.2,5.2-0.5,9-0.7 c40.1-2.4,87.9,13.1,113.4,22.5 M521.4,661.3c15,3.2,36.8,5.7,61-0.1c74.9-17.9,124.8-102.7,129.6-180.1 c3-47.8-11.3-94.5-37.4-132.4 M561.7,576.9c9,7.7,20.9,11.8,32.7,11.3 M650.5,358c6.6-1.3,28.5-6.4,42.4-26.2 c16.4-23.4,18.3-62.6-5.4-80.6c-22.6-17.2-56.2-5.7-74.4,10.4c-18.5,16.4-22,38.5-22.8,45.5 M671.5,260.2c-6.5,0.2-22.5,1.7-38,13 c-21.9,16.1-26.2,39.9-27,45 M418.4,273.6c-3-20.9-20.8-38.7-41.7-41.7c-22.3-3.2-43.1,9.5-51.8,28.1c-10.3,22.1-2.4,50,19.6,64.6  M392.5,284.9c-1.8-4.5-6.3-14.3-16.7-22.4c-9.4-7.4-18.9-9.8-23.6-10.6 M345.4,677.4c17.2,4.8,37.1-2.3,47.3-16.9 M376.5,720.9 c2.7,0.8,10.7,2.6,19.7-1c12.1-4.8,16.6-15.7,17.3-17.7 M410.5,752.6c10.1-0.8,19.7-7.2,24.2-16.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M381.5,465.2c-17-101.3,53.8-170.9,34-184c-17.8-11.7-82.6,37.9-113.5,103.2c-32.9,69.6-17.6,138.1-10.5,163.8 c0,0,21.5,122.7,114.5,201.1c19.7,16.6,36.7,25.6,53.8,21.6c18.9-4.4,35.2-23,36.7-41.7c1.4-16.9-9.5-30.5-13-35 C446.6,647,392.5,530.9,381.5,465.2z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "head"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M674.6,348.7c26.1,37.9,40.4,84.6,37.4,132.4c-4.8,77.4-54.7,162.2-129.6,180.1c-23.2,5.6-44.1,3.6-59.1,0.5 c-16.2,12.3-32.1,21-33.6,37.5c-0.1,1.5-0.1,2.9,0,4.1c-2.5-4.2-5-7.4-6.3-9.1c-36.8-47.3-91-163.3-102-229 c-17-101.3,53.8-171,34-184c-3.5-2.3-8.8-2.2-15.3-0.2c0.9-0.5,1.8-0.9,2.7-1.4c3-1.5,8.2-3.9,15.4-6.7 c13.3-5.1,33.1-11.1,57.3-13.5c2.2-0.2,5.2-0.5,9-0.7c40-2.4,87.9,13.1,113.4,22.5c3.4-6.6,8.2-13.6,15.1-19.7 c18.2-16.2,51.8-27.6,74.4-10.4c23.6,18,21.8,57.2,5.4,80.6C687.5,339.4,681,344.9,674.6,348.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M489.8,703.3c3.8,6.5,7.5,15.6,6.7,25.9C497.3,716.8,490.6,712.8,489.8,703.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M343.5,323.9c19.4-20.1,40-34.3,56.6-42.9c6.5-2.1,11.8-2.1,15.3,0.2c19.8,13-51,82.7-34,184 c11,65.7,65.2,181.7,102,229c1.4,1.8,3.9,4.9,6.3,9.1c0.8,9.5,7.5,13.4,6.7,25.9c-1,12.6-8.7,25.1-19.4,33.3 c-0.3,0.2-0.5,0.4-0.8,0.6c-0.3,0.2-0.5,0.4-0.8,0.5c-0.8,0.5-1.5,1.1-2.3,1.6c-0.5,0.3-1.1,0.7-1.6,1c-1.9,1.1-3.8,2-5.8,2.8 c-0.3,0.1-0.6,0.2-0.9,0.3c-1.7,0.7-3.5,1.2-5.2,1.6c-17.1,4-34.1-5-53.8-21.6c-10.6-9-20.3-18.5-29.2-28.4 c-68.5-76.5-85.3-172.8-85.3-172.8c-8.1-46.5-17.9-102.3,10.5-163.7c8.2-17.4,18.8-33.6,30.3-47.9c0,0,0,0,0,0 C335.9,332.1,339.7,327.9,343.5,323.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M392.2,284.3c-14.2,6.9-32,20.9-49,39.4c-21-14.8-28.5-42.1-18.4-63.8c8.7-18.7,29.5-31.4,51.8-28.1 c20.7,3,38.4,20.6,41.6,41.2c-7.2,2.7-12.4,5.2-15.4,6.7c-0.9,0.4-1.8,0.9-2.7,1.4C397.7,281.9,395,283,392.2,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M392.2,284.3c2.8-1.4,5.5-2.5,8-3.3c-16.6,8.5-37.3,22.8-56.6,42.9c-0.1-0.1-0.2-0.1-0.3-0.2 C360.2,305.2,378,291.2,392.2,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M343.3,323.7c0.1,0.1,0.2,0.1,0.3,0.2c-3.8,4-7.6,8.2-11.3,12.6C335.8,332.1,339.5,327.8,343.3,323.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M301.9,384.5c-28.4,61.4-18.6,117.2-10.5,163.7C284.3,522.6,269,454.1,301.9,384.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M574.7,583.4c-0.1,0.4-0.3,0.8-0.4,1.3c-11.4,37.6-28.9,58.5-42.9,70.6c-2.7,2.3-5.4,4.5-8.1,6.5 c-16.2,12.3-32.1,21-33.6,37.5c-0.1,1.5-0.1,2.9,0,4.1c0.8,9.5,7.5,13.4,6.7,25.9c-0.8,12.3-8.5,25-19.4,33.3 c-0.3,0.2-0.5,0.4-0.8,0.6c-0.3,0.2-0.5,0.4-0.8,0.5c-0.8,0.5-1.5,1.1-2.3,1.6c-0.5,0.3-1.1,0.7-1.6,1c-1.9,1.1-3.8,2-5.8,2.8 c-0.3,0.1-0.6,0.2-0.9,0.3c-1.7,0.7-3.5,1.2-5.2,1.6c-17.1,4-34.1-5-53.8-21.6c-10.6-9-20.3-18.5-29.2-28.4 c-68.5-76.5-85.3-172.8-85.3-172.8c-8.1-46.5-17.9-102.3,10.5-163.7c8.4-18.2,18.9-34.2,30.3-47.9c0,0,0,0,0,0 c3.7-4.4,7.5-8.6,11.3-12.6c19.4-20.1,40-34.3,56.6-42.9c0.9-0.5,1.8-0.9,2.7-1.4c3-1.5,8.2-3.9,15.4-6.7 c13.3-5.1,33.1-11.1,57.3-13.5c2.2-0.2,5.2-0.5,9-0.7c40-2.4,87.9,13.1,113.4,22.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M521.4,661.3c0.6,0.1,1.3,0.3,1.9,0.4c15,3,35.9,5,59.1-0.5c74.9-17.9,124.8-102.7,129.6-180.1 c3-47.8-11.3-94.5-37.4-132.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M561.7,576.9c3.8,3.2,8,5.8,12.6,7.7c6.4,2.6,13.3,3.9,20.1,3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M650.5,358c4-0.8,13.9-3,24.2-9.3c6.4-3.9,12.9-9.3,18.2-16.9c16.4-23.4,18.3-62.6-5.4-80.6 c-22.6-17.2-56.2-5.7-74.4,10.4c-6.9,6.1-11.7,13-15.1,19.7c-5.7,11.1-7.2,21.4-7.7,25.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M671.5,260.2c-6.5,0.2-22.5,1.7-38,13c-21.9,16-26.2,39.9-27,45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M418.4,273.6c0-0.2,0-0.4-0.1-0.5c-3.2-20.6-20.9-38.2-41.6-41.2c-22.3-3.3-43.1,9.4-51.8,28.1 c-10.1,21.7-2.6,48.9,18.4,63.8c0.1,0.1,0.2,0.1,0.3,0.2c0.3,0.2,0.6,0.4,0.9,0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M392.5,284.9c-0.1-0.2-0.1-0.4-0.2-0.6c-1.9-4.7-6.5-14.1-16.4-21.9c-9.4-7.4-18.9-9.8-23.6-10.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M345.4,677.4c17.2,4.8,37.1-2.3,47.4-16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M376.5,720.9c0.1,0,0.2,0,0.3,0.1c3,0.8,10.7,2.4,19.4-1.1c12.1-4.8,16.6-15.7,17.3-17.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M410.5,752.6c10.1-0.8,19.7-7.2,24.2-16.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 534.5,
    cy: 449.7,
    rx: 46,
    ry: 52.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 553,
    cy: 434.7,
    rx: 18.5,
    ry: 23.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 525.5,
    cy: 471.2,
    rx: 14,
    ry: 19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 528,
    cy: 459.7,
    rx: 57.5,
    ry: 65.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M471.7,569.4c4-10.7,7.9-21.5,11.9-32.2c1.7-4.5-5.6-6.5-7.2-2c-4,10.7-7.9,21.5-11.9,32.2 C462.8,571.9,470,573.9,471.7,569.4L471.7,569.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M495.4,569.4c4-10.7,7.9-21.5,11.9-32.2c1.7-4.5-5.6-6.5-7.2-2c-4,10.7-7.9,21.5-11.9,32.2 C486.5,571.9,493.7,573.9,495.4,569.4L495.4,569.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M519.1,569.4c4-10.7,7.9-21.5,11.9-32.2c1.7-4.5-5.6-6.5-7.2-2c-4,10.7-7.9,21.5-11.9,32.2 C510.2,571.9,517.5,573.9,519.1,569.4L519.1,569.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M542.9,569.4c4-10.7,7.9-21.5,11.9-32.2c1.7-4.5-5.6-6.5-7.2-2c-4,10.7-7.9,21.5-11.9,32.2 C534,571.9,541.2,573.9,542.9,569.4L542.9,569.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M566.6,569.4c4-10.7,7.9-21.5,11.9-32.2c1.7-4.5-5.6-6.5-7.2-2c-4,10.7-7.9,21.5-11.9,32.2 C557.7,571.9,564.9,573.9,566.6,569.4L566.6,569.4z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapirHex);
export default __webpack_public_path__ + "static/media/tapir-hex.760252672301a15e6bad46a483bdbf5e.svg";
export { ForwardRef as ReactComponent };